module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-toc-title"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/authorsnote"
    }
  }, [_vm._v("AUTHOR’S NOTE")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_01"
    }
  }, [_vm._v("CHAPTER ONE: Lynda Ann Healy")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chapter_02"
    }
  }, [_vm._v("CHAPTER TWO: Georgann Hawkins")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THREE: Kathy Parks")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOUR: Susan Rancourt")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIVE: The Lake Sammamish Reports #1")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIX: The Lake Sammamish Reports #2")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVEN: King County Reports for Leon County")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHT: Seattle Reports and Articles")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINE: Don Patchen Reports and Investigative Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TEN: Summary Report on the Chi Omega Murders")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ELEVEN: Reports, Revelations, and Suspected Bundy Murders")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWELVE: Jerry Thompson Reports")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTEEN: Report on the Kimberly Diane Leach Murder")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOURTEEN: Bundy Florida Arrest Reports")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTEEN: A Letter from Bundy’s Roommate")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIXTEEN: Interviews and Testimonies of Other Witnesses")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVENTEEN: Dr. Al Carlisle")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('br')]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/photographs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PHOTOGRAPHS")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97f42f88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 66
// module chunks = 0